import { useFooterData } from '@/hooks/useFooterData';

export function Footer() {
  const { footerData } = useFooterData();

  return (
    <footer className="bg-[#19305c] text-white">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div className="space-y-2">
            <p className="font-semibold text-white">
              {footerData.contact.hours}
            </p>
            <p className="font-semibold text-white">
              Phone: {footerData.contact.phone}
            </p>
            <div className="space-y-1">
              <p className="text-white">
                <span className="font-semibold">Sales:</span>{' '}
                <a 
                  href={`mailto:${footerData.contact.salesEmail}`}
                  className="text-[#faff0a] hover:text-yellow-200 transition-colors"
                >
                  {footerData.contact.salesEmail}
                </a>
              </p>
              <p className="text-white">
                <span className="font-semibold">Shipping:</span>{' '}
                <a 
                  href={`mailto:${footerData.contact.shippingEmail}`}
                  className="text-[#faff0a] hover:text-yellow-200 transition-colors"
                >
                  {footerData.contact.shippingEmail}
                </a>
              </p>
              <p className="text-white">
                <span className="font-semibold">Technical:</span>{' '}
                <a 
                  href={`mailto:${footerData.contact.technicalEmail}`}
                  className="text-[#faff0a] hover:text-yellow-200 transition-colors"
                >
                  {footerData.contact.technicalEmail}
                </a>
              </p>
            </div>
            <div className="pt-2">
              <p className="text-white text-sm">
                {footerData.contact.address.company}
              </p>
              <p className="text-white text-sm">
                {footerData.contact.address.street}
              </p>
              <p className="text-white text-sm">
                {footerData.contact.address.city} {footerData.contact.address.state} {footerData.contact.address.zip}
              </p>
            </div>
          </div>

          {/* Color Picker */}
          <div className="flex justify-center items-start">
            <a 
              href={footerData.colorPickerUrl}
              target="_blank"
              rel="noreferrer noopener"
              className="block hover:opacity-80 transition-opacity"
            >
              <img 
                src={footerData.colorPickerImage}
                alt="Color Picker"
                className="max-w-full h-auto"
              />
            </a>
          </div>

          {/* Cart Status */}
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-white">Cart</h3>
            <p className="text-white text-sm">
              {footerData.cart.message}
            </p>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-[#19305c] border-t border-[#315394] py-4">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-white text-sm">
            {footerData.copyright} •{' '}
            <a 
              href={footerData.siteByUrl}
              className="text-[#faff0a] hover:text-yellow-200 transition-colors"
              target="_blank"
              rel="noreferrer noopener"
            >
              {footerData.siteByText}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}